module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 8
// module chunks = 0